"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisuallyHidden = void 0;
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../hooks");
exports.VisuallyHidden = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.hidden, hidden = _b === void 0 ? false : _b, children = _a.children;
    var hiddenStyle = hooks_1.useVisuallyHidden().hiddenStyle;
    return (react_1.default.createElement("div", { ref: ref, style: hidden ? hiddenStyle : null }, children ? react_1.default.createElement(react_1.default.Fragment, null, children) : null));
});
//# sourceMappingURL=VisuallyHidden.js.map